import {
    Box,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    SelectChangeEvent,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import {
    WeekDay,
    OccurrenceType,
    WEEKDAYS,
    OCCURRENCES,
} from '../../../types/inventoryReminder';

interface RelativeDayPickerProps {
    occurrence: OccurrenceType | undefined;
    dayOfWeek: WeekDay | undefined;
    onOccurrenceChange: (occurrence: OccurrenceType) => void;
    onDayOfWeekChange: (dayOfWeek: WeekDay) => void;
    disabled?: boolean;
}

const RelativeDayPicker = ({
    occurrence,
    dayOfWeek,
    onOccurrenceChange,
    onDayOfWeekChange,
    disabled = false,
}: RelativeDayPickerProps) => {
    const { t } = useTranslation();

    const handleOccurrenceChange = (event: SelectChangeEvent) => {
        onOccurrenceChange(event.target.value as OccurrenceType);
    };

    const handleDayOfWeekChange = (event: SelectChangeEvent) => {
        onDayOfWeekChange(event.target.value as WeekDay);
    };

    return (
        <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
            <FormControl sx={{ minWidth: 150 }} disabled={disabled}>
                <InputLabel>
                    {t('settings.inventoryReminder.occurrence.label')}
                </InputLabel>
                <Select
                    value={occurrence || ''}
                    onChange={handleOccurrenceChange}
                    label={t('settings.inventoryReminder.occurrence.label')}
                >
                    {OCCURRENCES.map((occ) => (
                        <MenuItem key={occ.value} value={occ.value}>
                            {t(occ.labelKey)}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>

            <FormControl sx={{ minWidth: 150 }} disabled={disabled}>
                <InputLabel>
                    {t('settings.inventoryReminder.weekday.label')}
                </InputLabel>
                <Select
                    value={dayOfWeek || ''}
                    onChange={handleDayOfWeekChange}
                    label={t('settings.inventoryReminder.weekday.label')}
                >
                    {WEEKDAYS.map((day) => (
                        <MenuItem key={day.value} value={day.value}>
                            {t(day.labelKey)}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Box>
    );
};

export default RelativeDayPicker;
